<template>
	<div class="edit_wrap" style="word-break:break-all;">
		<div class="edit_top">
			<div class="edit_tab" :class="{ 'active_tab': isStep === 1 }" @click="changeTab(1)">供应商信息</div><!--
    --><div class="edit_tab" :class="{ 'active_tab': isStep === 2 }" @click="changeTab(2)">品牌信息</div><!--
    --><div class="edit_tab" :class="{ 'active_tab': isStep === 3 }" @click="changeTab(3)">财务信息</div><!--
    --><div class="edit_tab" :class="{ 'active_tab': isStep === 4 }"  @click="changeTab(4)">合同协议</div>
		</div>
		<div class="tip_word">
			<el-row>
				<el-col :span="2">
					<div class="grid-content">友情提示：</div>
				</el-col>
				<el-col :span="22"><div class="grid-content f12 f666 lh20">1.请按照大V服务平台信息要求填写正确的供应商信息。</div></el-col>
			</el-row>
			<el-row>
				<el-col :span="22" :offset="2"><div class="grid-content f12 f666 lh20">2.所有资质信息格式要求：复印件加盖公司红章之后，再扫描上传到大V服务平台。请确保证件内容清晰可见，扫描件大小不得超过1M。</div></el-col>
			</el-row>
			<el-row>
				<el-col :span="22" :offset="2"><div class="grid-content f12 f666 lh20">3.提交审核之后，大V店工作人员会在3个工作日内进行审核。</div></el-col>
			</el-row>
			<el-row>
				<el-col :span="22" :offset="2"><div class="grid-content f12 f666 lh20">4.入驻过程有任何疑问，请按照如下方式解决：<br>（1）如果有对接的采销，请直接联系采销处理解决；<br>（2）如果还未对接采销，直接发送问题至邮箱：bd@davdian.com 。</div></el-col>
			</el-row>
			<el-row>
				<el-col :span="22" :offset="2"><div class="grid-content f12 f666 lh20">5.<a target="_blank" href="/suppliers/index2/#/intro"><span style="color: #58b7ff">点击此处</span></a>查看供应商入驻介绍。</div></el-col>
			</el-row>
		</div>
		<basicInfo v-show="isStep == 1"></basicInfo>
		<brandList v-show="isStep == 2"></brandList>
		<financeInfo v-show="isStep == 3"></financeInfo>
		<argeementList  v-show="isStep == 4"></argeementList>
		<div align="center" style="margin-top: 20px;"  v-show="showButton == 1">
			<el-button  type="primary" icon="arrow-left" v-show="isStep > 1" @click="upPage">上一页</el-button>
			<el-button  type="primary" v-show="isStep < 4" @click="nextPage">下一页<i class="el-icon-arrow-right el-icon--right"></i></el-button>
		</div>
	</div>
</template>

<script type="text/javascript">
	import basicInfo from './basicInfo.vue'
	import brandList from './brandList.vue'
	import financeInfo from './financeInfo.vue'
	import argeementList from './agreementList.vue'
    export default {
        components: {
            basicInfo: basicInfo,
            brandList: brandList,
            financeInfo: financeInfo,
            argeementList: argeementList
        },
        data () {
            return {
                showButton:1,
                argeementListShowButton:1,
                isActiveTab: true,
                isStep: 1
            }
        },
        methods: {
            changeTab(step){
                if(step==4 && this.argeementListShowButton==0) {
                    this.showButton = 0;
                }else{
                    this.showButton = 1;
                }
                this.isStep = step;
            },
            upPage(){
                this.showButton = 1;
                if(this.isStep>1) {
                    this.isStep = this.isStep - 1;
                }
            },
            nextPage(){
                if(this.isStep<4) {
                    if(this.isStep==3 && this.argeementListShowButton==0) {
                        this.showButton = 0;
                    }else{
                        this.showButton = 1;
                    }
                    this.isStep = this.isStep + 1;
                }
            }
        },
        mounted(){
            this.supplierApplyId = this.$route.query.supplierApplyId;
            var step=this.$route.query.isStep;
            console.log(step);
            step = step * 1;
            if(step && step>1 && step <5) {
                this.isStep = step;
            }
        }
    };
</script>

<style type="text/css" lang="less" scoped>
	.edit_wrap {
		width: 1050px;
	  // height: 4000px;
	  margin: 50px auto;
	  border: 1px solid #eee;
	  // padding: 20px;
	  .edit_tab {
	  	display: inline-block;
	  	width: 262px;
	  	height: 46px;
	  	text-align: center;
	  	line-height: 46px;
	  	color: #fff;
	  	background: #ff6c83;
	  }
	  .active_tab {
	  	background: #ff4a7d;
	  }
	  .tip_word {
	  	margin-top: 20px;
	  	width: 1048px;
	  	height: 160px;
	  	background: #f9f9f9;
	  	padding: 10px;
	  }
	}
	.lh20 {
		line-height: 20px;
	}
</style>


// WEBPACK FOOTER //
// suppliercommonPages.vue?2a3b2c7c